import {Badge, css, view} from '@sail/ui/deprecated';
import {defineMessages, FormattedMessage, useIntl} from 'react-intl';
import {useContext} from 'react';
import {noTranslateMessages} from '../helpers/noTranslate';
import {ConfigContext} from '../Providers/ConfigProvider';

const messages = defineMessages({
  defaultTitle: {
    id: 'support_conversations_client.header.universal_help_title',
    description:
      'The default title displayed in the conversation widget header.',
    defaultMessage: 'Stripe Support',
  },
  linkTitle: {
    id: 'support_conversations_client.supportWidget.LinkHeaderTitle.title',
    description: 'The title of the support widget on the Link Support Site',
    defaultMessage: 'Link Support',
  },
});

const testMessages = noTranslateMessages({
  devLabel: {
    id: 'support_conversations_client.header.devTag.label',
    description: 'Label used for dev mode',
    defaultMessage: 'DEV',
  },
  syntheticLabel: {
    id: 'support_conversations_client.header.syntheticTag.label',
    description: 'Label used for synthetic tests',
    defaultMessage: 'Synthetic',
  },
});

export function DevBadge() {
  const intl = useIntl();
  return <Badge type="info">{intl.formatMessage(testMessages.devLabel)}</Badge>;
}

export function SyntheticBadge() {
  const intl = useIntl();
  return (
    <Badge type="info">{intl.formatMessage(testMessages.syntheticLabel)}</Badge>
  );
}

export function Title({testMode}: {testMode?: 'dev' | 'synthetic'}) {
  let testBadge = null;
  if (testMode === 'dev') {
    testBadge = <DevBadge />;
  } else if (testMode === 'synthetic') {
    testBadge = <SyntheticBadge />;
  }

  const {audience} = useContext(ConfigContext);

  const titleMsg =
    audience === 'link' ? messages.linkTitle : messages.defaultTitle;
  const title = <FormattedMessage {...titleMsg} />;

  return (
    <view.div
      css={{
        stack: 'x',
        gap: 'small',
        alignY: 'center',
        textAlign: css.value('center'),
      }}
    >
      {title} {testBadge}
    </view.div>
  );
}
